import { RouteConfig } from "vue-router"
import GlobalDashboardLayout from "@/layouts/GlobalDashLayout.vue"
import { ROLES } from "@/constants/roles"

export const globalSettingsRoutes: RouteConfig[] = [
    {
        path: "/settings",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: {
            title: "Settings",
            doNotShow: true,
            requiresAuth: true,
            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
        },
        children: [
            {
                path: "global",
                component: GlobalDashboardLayout,
                name: "GlobalSettings",
                meta: {
                    title: "Global Settings",
                    auth: true,
                    doNotVisit: true,
                    requiresAuth: true,
                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                },
                children: [
                    {
                        path: "companies",
                        component: () => import("@/layouts/Wrapper.vue"),
                        meta: {
                            title: "Companies",
                            doNotShow: true,
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                        },
                        children: [
                            {
                                path: ":companyId",
                                component: () => import("@/layouts/Wrapper.vue"),
                                meta: {
                                    title: "Company",
                                    type: "company",
                                    requiresAuth: true,
                                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "GlobalSettingsOverview",
                                        component: () => import("@/views/GlobalOverview.vue"),
                                        meta: {
                                            title: "Overview",
                                            requiresAuth: true,
                                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                                        },
                                    },
                                    {
                                        path: "location-groups",
                                        component: () => import("@/layouts/Wrapper.vue"),
                                        meta: {
                                            title: "Locations & Groups",
                                            requiresAuth: true,
                                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                                        },
                                        children: [
                                            {
                                                path: "",
                                                name: "GlobalSettingsLocationsGroups",
                                                component: () =>
                                                    import("@/views/GlobalLocationGroups.vue"),
                                                meta: {
                                                    title: "Locations & Groups",
                                                    requiresAuth: true,
                                                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                                                },
                                            },
                                            {
                                                path: ":locationGroupId",
                                                component: () => import("@/layouts/Wrapper.vue"),
                                                meta: {
                                                    title: "Location Group",
                                                    requiresAuth: true,
                                                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        component: () =>
                                                            import("@/layouts/Wrapper.vue"),
                                                        meta: {
                                                            title: "Location Group Overview",
                                                            requiresAuth: true,
                                                            permissions: [
                                                                ROLES.ADMIN,
                                                                ROLES.AGGREGATOR,
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        path: "locations",
                                                        component: () =>
                                                            import("@/layouts/Wrapper.vue"),
                                                        meta: {
                                                            title: "Locations",
                                                            maintainsContext: true,
                                                            requiresAuth: true,
                                                            permissions: [
                                                                ROLES.ADMIN,
                                                                ROLES.AGGREGATOR,
                                                            ],
                                                        },
                                                        children: [
                                                            {
                                                                path: "",
                                                                component: () =>
                                                                    import("@/layouts/Wrapper.vue"),
                                                                meta: {
                                                                    title: "Locations Overview",
                                                                    requiresAuth: true,
                                                                    permissions: [
                                                                        ROLES.ADMIN,
                                                                        ROLES.AGGREGATOR,
                                                                    ],
                                                                },
                                                            },
                                                            {
                                                                path: ":locationId",
                                                                component: () =>
                                                                    import("@/layouts/Wrapper.vue"),
                                                                meta: {
                                                                    title: "Location",
                                                                    maintainsContext: true,
                                                                    requiresAuth: true,
                                                                    permissions: [
                                                                        ROLES.ADMIN,
                                                                        ROLES.AGGREGATOR,
                                                                    ],
                                                                },
                                                                children: [
                                                                    {
                                                                        path: "",
                                                                        name: "GlobalLocationView",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/GlobalLocationView.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Location",
                                                                            type: "location",
                                                                            maintainsContext: true,
                                                                            requiresAuth: true,
                                                                            permissions: [
                                                                                ROLES.ADMIN,
                                                                                ROLES.AGGREGATOR,
                                                                            ],
                                                                        },
                                                                    },
                                                                    {
                                                                        path: "users",
                                                                        component: () =>
                                                                            import(
                                                                                "@/layouts/Wrapper.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Users",
                                                                            maintainsContext: true,
                                                                            requiresAuth: true,
                                                                            permissions: [
                                                                                ROLES.ADMIN,
                                                                                ROLES.AGGREGATOR,
                                                                            ],
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "locations",
                                        name: "GlobalSettingsLocations",
                                        component: () => import("@/views/GlobalLocations.vue"),
                                        meta: { title: "Locations" },
                                    },
                                    {
                                        path: "oem-devices",
                                        name: "GlobalSettingsOEMDevices",
                                        component: () => import("@/views/GlobalOEMDevices.vue"),
                                        meta: {
                                            title: "Devices",
                                            useDynamicTitle: true,
                                            isContextSource: true,
                                        },
                                        children: [
                                            {
                                                path: ":oemDeviceId",
                                                name: "GlobalLocationOEMDevicesView",
                                                component: () =>
                                                    import(
                                                        "@/views/settings/oem-device/OEMDevice.vue"
                                                    ),
                                                meta: { title: "Overview" },
                                            },
                                        ],
                                    },
                                    {
                                        path: "users",
                                        name: "GlobalSettingsUsers",
                                        component: () => import("@/views/GlobalUsers.vue"),
                                        meta: { title: "Users" },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
]
